export const ELEMENT_MODAL_ELEMENT_ID_SET = 'ELEMENT_MODAL_ELEMENT_ID_SET';
export const ELEMENT_MODAL_ELEMENT_ID_CLEAR = 'ELEMENT_MODAL_ELEMENT_ID_CLEAR';
